import { render, staticRenderFns } from "./ClientUsersFilters.vue?vue&type=template&id=1c6537b5"
import script from "./ClientUsersFilters.vue?vue&type=script&lang=js"
export * from "./ClientUsersFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports